<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      class="padding-b pb-md-12"
    >
      <TituloPagina
        class="mt-5 mt-md-11"
        :titulo="titulo"
      />
      <p
        class="pa-0 mt-5 mb-0 primary--text"
        data-cy="texto_da_pagina"
      >
        Dê um apelido para seu endereço
      </p>

      <v-form
        ref="form"
        class="mt-3"
      >
        <v-col class="my-0 pa-0">
          <v-text-field
            v-model.trim="form.nickname"
            filled
            maxlength="20"
            background-color="white"
            label="Ex: Meu trabalho"
            data-cy="endereco_apelido"
            :error-messages="errorFormApelido"
            :loading="inputLoading"
            @blur="$v.form.nickname.$touch()"
          />

          <p
            id="titulo-endereco"
            class="mt-0 body-2 primary--text"
          >
            Endereço
          </p>

          <v-text-field
            v-model="form.zip_code"
            v-mask="'#####-###'"
            filled
            label="CEP"
            background-color="white"
            data-cy="endereco_cep"
            class="input_cep"
            maxlength="9"
            :error-messages="errorFormCep()"
            :loading="inputLoading"
            @input.native="limparDados()"
            @blur="$v.form.zip_code.$touch()"
          >
            <template v-slot:append-outer>
              <v-btn
                class="btn_check_cep"
                color="indigo lighten-4"
                depressed
                data-cy="btn_buscar_cep"
                :loading="btCepLoading"
                @click="buscarCep()"
              >
                <v-icon>
                  mdi-check
                </v-icon>
              </v-btn>
            </template>
          </v-text-field>

          <template v-if="expandirForm">
            <v-select
              id="estado"
              v-model="form.state"
              background-color="white"
              data-cy="endereco_estado"
              filled
              label="Estado"
              :error-messages="errorFormEstado"
              :items="estados"
              :loading="inputLoading"
              @blur="$v.form.state.$touch()"
            />
            <v-text-field
              v-model.trim="form.city"
              background-color="white"
              data-cy="endereco_cidade"
              filled
              label="Cidade"
              maxlength="100"
              :error-messages="errorFormCidade"
              :loading="inputLoading"
              @blur="$v.form.city.$touch()"
            />

            <v-text-field
              v-model.trim="form.neighborhood"
              background-color="white"
              data-cy="endereco_bairro"
              filled
              label="Bairro"
              maxlength="100"
              :loading="inputLoading"
              :error-messages="errorFormBairro"
              @blur="$v.form.neighborhood.$touch()"
            />

            <v-text-field
              v-model.trim="form.street"
              background-color="white"
              data-cy="endereco_endereco"
              filled
              label="Logradouro"
              maxlength="200"
              :error-messages="errorFormLogradouro"
              :loading="inputLoading"
              @blur="$v.form.street.$touch()"
            />

            <v-text-field
              v-model.trim="form.number"
              background-color="white"
              data-cy="endereco_numero"
              filled
              label="Número"
              maxlength="100"
              :error-messages="errorFormNumero"
              :loading="inputLoading"
              @blur="$v.form.number.$touch()"
            />

            <v-text-field
              v-model.trim="form.complement"
              background-color="white"
              data-cy="endereco_complemento"
              filled
              label="Complemento"
              maxlength="150"
              :loading="inputLoading"
            />
          </template>
        </v-col>
      </v-form>

      <div
        :class="$vuetify.breakpoint.mdAndUp
          ? 'botoes-rodape--desktop' : 'botoes-rodape--mobile'"
        class="grey lighten-3 botoes-rodape pa-3 px-md-0 mt-md-4"
      >
        <v-btn
          :width="$vuetify.breakpoint.mdAndUp ? '248' : '143'"
          color="primary"
          outlined
          exact
          data-cy="btn_voltar"
          to="/meu-perfil/enderecos"
        >
          Voltar
        </v-btn>

        <v-btn
          color="primary"
          data-cy="btn_salvar"
          :width="$vuetify.breakpoint.mdAndUp ? '248' : '143'"
          :disabled="btSalvarDisabled"
          :loading="btSalvarLoading"
          @click="salvarDados()"
        >
          Salvar
        </v-btn>
      </div>

      <SnackBar
        :mensage="snackBar.message"
        :snackbar="snackBar.show"
        :button="true"
        :color="snackBar.color"
        :timeout="snackBar.timeout"
        @changeSnackBar="respostaSnackbar($event)"
      />
    </InternaMain>
  </Wrapper>
</template>

<script>
import { mask } from 'vue-the-mask';
import { required, minLength } from 'vuelidate/lib/validators';
import api from '@/api';

import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import SnackBar from '@/components/SnackBar.vue';

export default {
  name: 'EnderecosCadastrar',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    TituloPagina,
    SnackBar,
  },

  directives: { mask },

  filters: {
    maskCep(value) {
      if (!value) return '';
      const valorComMask = `${value.slice(0, 5)}-${value.slice(5)}`;
      return valorComMask;
    },
  },

  beforeRouteEnter(to, from, next) {
    if (from.name === 'enderecos') {
      return next();
    }
    return next('/meu-perfil/enderecos');
  },

  props: {
    idEndereco: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      titulo: 'Adicionar endereço',
      expandirForm: false,
      inputLoading: false,
      btCepLoading: false,
      btSalvarDisabled: true,
      btSalvarLoading: false,
      retornarLista: false,
      semAlteracao: false,
      formEditado: 0,
      mascaraCep: '#####-##',
      urlApi: {
        endereco: '/address',
        cep: '/address/zip_code',
      },
      form: {
        nickname: '',
        zip_code: '',
        state: '',
        city: '',
        neighborhood: '',
        street: '',
        number: '',
        complement: '',
      },
      estados: [
        'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF',
        'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA',
        'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS',
        'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
      ],
      mensagens: {
        invalido: 'Preencha o campo corretamente.',
        obrigatorio: 'Por favor, preencha o campo.',
      },
      snackBar: {
        message: '',
        color: 'success',
        timeout: 5000,
        show: false,
      },
      snackBarMensagens: {
        cep: 'CEP não encontrado. Preencha os campos do endereço.',
        error: 'Tente novamente mais tarde.',
        sucesso: 'Endereço adicionado.',
      },
    };
  },

  computed: {
    errorFormApelido() {
      if (this.$v.form.nickname.$invalid
        && this.$v.form.nickname.$dirty) return this.mensagens.obrigatorio;
      return [];
    },

    errorFormEstado() {
      if (this.$v.form.state.$invalid
        && this.$v.form.state.$dirty) return this.mensagens.obrigatorio;
      return [];
    },

    errorFormCidade() {
      if (this.$v.form.city.$invalid
        && this.$v.form.city.$dirty) return this.mensagens.obrigatorio;
      return [];
    },

    errorFormBairro() {
      if (this.$v.form.neighborhood.$invalid
        && this.$v.form.neighborhood.$dirty) return this.mensagens.obrigatorio;
      return [];
    },

    errorFormLogradouro() {
      if (this.$v.form.street.$invalid
        && this.$v.form.street.$dirty) return this.mensagens.obrigatorio;
      return [];
    },

    errorFormNumero() {
      if (this.$v.form.number.$invalid
        && this.$v.form.number.$dirty) return this.mensagens.obrigatorio;
      return [];
    },
  },

  watch: {
    form: {
      handler() {
        if (!this.semAlteracao) {
          this.btSalvarDisabled = this.$v.form.$invalid;
        } else {
          this.verificaFormAlterado();
        }
      },
      deep: true,
    },
  },

  created() {
    if (this.idEndereco) {
      this.expandirForm = true;
      this.semAlteracao = true;
      this.buscarEndereco();
    }
  },

  validations() {
    return {
      form: {
        nickname: {
          required,
        },
        zip_code: {
          required,
          minLength: minLength(9),
        },
        state: {
          required,
        },
        city: {
          required,
        },
        neighborhood: {
          required,
        },
        street: {
          required,
        },
        number: {
          required,
        },
      },
    };
  },

  methods: {
    verificaFormAlterado() {
      if (this.formEditado < 1) {
        this.formEditado += 1;
      } else {
        this.semAlteracao = false;
        this.btSalvarDisabled = this.$v.form.$invalid;
      }
    },

    buscarCep() {
      if (this.$v.form.zip_code.$invalid || this.$v.form.nickname.$invalid) {
        this.$v.form.zip_code.$touch();
        this.$v.form.nickname.$touch();
        this.errorFormCep();
      } else {
        this.btCepLoading = true;
        let cep = this.form.zip_code;
        cep = cep.replace(/-/, '');

        api.get(`${this.urlApi.cep}/${cep}`)
          .then((response) => {
            const { data } = response;

            if (data.state) {
              Object.assign(this.form, data);
              this.form.zip_code = this.$options.filters.maskCep(this.form.zip_code);
            } else {
              this.setSnackbar(this.snackBarMensagens.cep, 'info', 10000);
              this.scroolPage('#titulo-endereco', 50);
              this.limparDados();
            }
            this.expandirForm = true;
          })
          .catch(() => {
            this.errorFormCep(true);
          })
          .finally(() => {
            this.btCepLoading = false;

            if (this.form.state) {
              this.scroolPage('#estado', 0);
            }
          });
      }
    },

    errorFormCep(forcaInvalido = false) {
      if (forcaInvalido) {
        this.form.zip_code = '';
        return this.mensagens.invalido;
      }
      if (this.$v.form.zip_code.$invalid
        && this.$v.form.zip_code.$dirty) return this.mensagens.invalido;
      return [];
    },

    setSnackbar(mensagem, status, timeout = 6000, retornaLista = false) {
      this.snackBar.message = mensagem;
      this.snackBar.color = status;
      this.snackBar.timeout = timeout;
      this.snackBar.show = true;
      this.retornarLista = retornaLista;
    },

    respostaSnackbar(value) {
      this.snackBar.show = value.visible;

      if (this.snackBar.color === 'success' || this.retornarLista) {
        this.$router.push('/meu-perfil/enderecos');
      }
    },

    salvarDados() {
      this.btSalvarLoading = true;
      const formDataObj = {};

      formDataObj.zip_code = this.form.zip_code.replace(/-/, '');
      formDataObj.state = this.form.state;
      formDataObj.city = this.form.city;
      formDataObj.neighborhood = this.form.neighborhood;
      formDataObj.street = this.form.street;
      formDataObj.number = this.form.number;
      formDataObj.complement = this.form.complement;
      formDataObj.nickname = this.form.nickname;

      if (this.idEndereco) {
        this.conectarApi(formDataObj, `${this.urlApi.endereco}/${this.idEndereco}`, 'put');
      } else {
        this.conectarApi(formDataObj, this.urlApi.endereco, 'post');
      }
    },

    buscarEndereco() {
      this.inputLoading = true;
      this.conectarApi('', `${this.urlApi.endereco}/${this.idEndereco}`, 'get');
    },

    async conectarApi(form, url, operacao) {
      let response = '';

      try {
        if (operacao === 'put') {
          await api.put(url, form);
        } else if (operacao === 'post') {
          await api.post(url, form);
        } else {
          response = await api.get(url);
        }

        if (operacao === 'get') {
          const { data } = response;
          Object.assign(this.form, data);
        } else {
          this.setSnackbar(this.snackBarMensagens.sucesso, 'success');
          this.btSalvarDisabled = true;
        }
      } catch {
        if (operacao === 'get') {
          this.setSnackbar(this.snackBarMensagens.error, 'error', 6000, true);
        } else {
          this.setSnackbar(this.snackBarMensagens.error, 'error');
        }
      } finally {
        this.btSalvarLoading = false;
        this.inputLoading = false;
      }
    },

    scroolPage(target, margin) {
      this.$vuetify.goTo(target, {
        duration: 1000,
        offset: margin,
        easing: 'linear',
      });
    },

    limparDados() {
      if (this.expandirForm && this.form.zip_code.length < 9) {
        Object.keys(this.form).forEach((key) => {
          if (key !== 'nickname' && key !== 'zip_code') {
            this.form[key] = '';
          }
          this.$v.form.$reset();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/scss/botoes-fixos.scss';

.input_cep .btn_check_cep {
  border-radius: 0 40% 40% 0;
  height: 56px;
}
</style>

<style lang="scss">
.input_cep .v-input__append-outer {
  height: 56px;
  margin: 0 !important;
  width: 56px;
}
</style>
